import Header from "../../Components/Header";

export default function Help() {
  return (
    <>
      <Header />

      <style>{`
        /* Keep it local to this page */
        .help { background:#fff; color:#253046; padding:32px 0; }
        .help .help__wrap { max-width: 900px; margin: 0 auto; line-height: 1.65; }

        /* --- Bullet & layout fixes (win against theme) --- */
        .help .help__flow { 
          display: block !important;
          width: 100% !important; max-width: none !important;
          column-count: 1 !important; -webkit-column-count: 1 !important; -moz-column-count: 1 !important;
        }
        .help .help__flow > * {
          flex: 0 0 100% !important; width: 100% !important;
          max-width: none !important; float: none !important; clear: none !important;
        }
        .help .help__flow ul {
          list-style: disc !important; list-style-position: outside !important;
          margin: 10px 0 16px 0; padding-left: 1.25rem;
          display: block !important; width: 100% !important; max-width: none !important;
          column-count: 1 !important;
        }
        .help .help__flow li {
          display: list-item !important;
          margin: 6px 0; line-height: 1.6;
          width: 100% !important; max-width: none !important;
          white-space: normal; overflow-wrap: normal; hyphens: manual;
        }
        .help .help__flow li::before, .help .help__flow ul::before { content: none !important; }
        .help .help__flow li::marker { color: #4b4b4b !important; }

        /* Headings/paragraphs (simple, readable) */
        .help h2 { font-size: 32px; font-weight: 700; margin: 0 0 12px; }
        .help h3 { font-size: 26px; font-weight: 700; margin: 28px 0 8px; }
        .help p  { margin: 0 0 14px; }
      `}</style>

      <section className="page3-slider help">
        <div className="container help__wrap">
          <h3>Who are Ezi Returns?</h3>
          <p>
            Ezi Returns are an independent international returns business
            providing streamlined returns solutions saving time and money for
            sellers and their customers.
          </p>
          <p>
            By using Ezi Returns, sellers can offer their customers a convenient
            and cost effective return method as though they are returning within
            their own country.
          </p>
          <p>
            Do not contact Ezi Returns about your return or refund as we are
            unable to help, You need to contact the seller directly.
          </p>

          <h3>How does it work?</h3>

          {/* Force single-column, full-width list rendering */}
          <div className="help__flow">
            <p>Once you have decided to return your unwanted items either:</p>

            <ul>
              <li>
                Contact the seller directly to receive returns instructions.
              </li>
              <li>
                If they have directed you here, go ahead and enter the
                information as prompted in our easy-to-use returns portal.
              </li>
            </ul>

            <p>
              After entering some information about yourself and your order, you
              will usually be offered a choice of services. Select the service
              you wish to use:
            </p>

            <ul>
              <li>
                You do not need to select the drop-off point to generate a
                label.
              </li>
              <li>
                Download and print the label. Attach it securely to your package
                ensuring all barcodes and addresses are clearly visible and not
                folded.
              </li>
              <li>
                Ensure you follow any instructions from the seller to include
                any paperwork, original labels, or tags as required.
              </li>
              <li>
                Drop your package off at a convenient drop-off point for the
                indicated courier or postal service.
              </li>
            </ul>

            <p>
              That’s it — usually a few days after processing at our return
              centre, your refund or exchange should be processed by the seller.
            </p>
          </div>

          <h3>Can I track the status of my return package?</h3>
          <p>
            Yes, you can use the tracking link from our website above or use the
            tracking available for your chosen courier directly to see if the
            item has arrived at the returns processing hub.
          </p>

          <h3>How long does it take to process my return?</h3>
          <p>
            All returns are usually registered within 48 hours or 2 working days
            of arrival at our Ezi Returns hubs. Local and national holidays or
            peak periods may see these timescales extended. Each seller will
            have their own timescales that they process refunds and exchanges
            in, so please allow sufficient time for them to process your return
            after arrival.
          </p>

          <h3>How quickly will I receive refund or exchange?</h3>
          <p>
            The time taken to process your refund is controlled by the seller,
            not Ezi Returns. Most sellers will process a refund within a few
            days of arrival at our Returns hub once we have processed and
            checked your return. Some sellers have longer processing times.
          </p>

          <h3>
            I have a query about my return, refund or exchange, what do I do?
          </h3>
          <p>
            If you have any query about your return, refund or exchange please
            contact the seller directly. Please do not contact Ezi Returns as we
            cannot help you with any such queries. The seller may have included
            their contact details such as email or website address in the
            confirmation email. Alternatively you will need to contact them
            through your account on marketplace you made the purchase.
          </p>

          <h3>Can I cancel my return request?</h3>
          <p>
            Yes, if you have changed your mind and wish to keep your purchase
            you do not need to do anything but it may be worth letting the
            seller know you have changed your mind.
          </p>

          <h3>
            I am a retailer interested in using Ezi Returns, how do I start?
          </h3>
          <p>
            Please contact us here and we will provide all the information
            explain how our service can help your business and your customers
            improve the return experience.
          </p>
        </div>
      </section>
    </>
  );
}
